import { KICK_STRENGTH } from '../constants/constants';

const numberToStrengthString = (value) => {
  switch (value) {
    case 1:
      return KICK_STRENGTH.VERY_LIGHT;
    case 2:
      return KICK_STRENGTH.LIGHT;
    case 3:
      return KICK_STRENGTH.MODERATE;
    case 4:
      return KICK_STRENGTH.STRONG;
    case 5:
      return KICK_STRENGTH.VERY_STRONG;
    default:
      return '';
  }
};

export default numberToStrengthString;
